import React, { useState, useEffect } from "react";

import Autocomplete from "../ui/Autocomplete";
import NuxeoClient from "../../clients/NuxeoClient";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";

import { useI18n } from "../../I18nProvider";

export default function Contract(props) {
  const appText = useI18n();
  const [isLoading, setIsLoading] = useState(false);
  const [fetchedData, setFetchedData] = useState([]);

  useEffect(() => {
    if (props.licenseeCode) {
      setIsLoading(true);
      _loadContractsDetails();
    }
  }, [props.licenseeCode]);

  async function _loadContractsDetails() {
    await NuxeoClient.instance()
      .fetchContracts(props.licenseeCode)
      .then((response) => {
        setIsLoading(false);
        setFetchedData(response.entries);
      });
  }

  const handleChange = (contract) => {
    props.handleChange("contract", contract.label);
    props.handleChange("contractID", contract.id);
  };

  return (
    // <Tooltip arrow title="Select the contract here">
    <Tooltip arrow title={appText.T115}>
      <Grid item={true} xs={12}>
        <div id="contract">
          <InputLabel className="field-label field-dropdown" required>
            {appText.T50}
          </InputLabel>
          <Autocomplete
            type={"single"}
            handleChange={handleChange}
            data={fetchedData}
            dataType={"contract"}
            mapVariable={"title"}
            setFilterData={() => null}
            value={props.value}
            isLoading={isLoading}
          />
        </div>
      </Grid>
    </Tooltip>
  );
}
